import PropTypes from 'prop-types'

import {List} from 'immutable'

import DraftDeputyBox from './DraftDeputyBox'

const MyDraftDeputies = ({draftDeputies, ...otherProps}) => {
  if (draftDeputies.isEmpty()) return null

  return (
    <div className='my-draft-deputies' data-testid='my-draft-deputies'>
      {
        draftDeputies.map(draftDeputy => (
          <DraftDeputyBox
            draftDeputy={draftDeputy}
            key={draftDeputy.get('id')}
            {...otherProps}
          />
        ))
      }
    </div>
  )
}

MyDraftDeputies.propTypes = {
  draftDeputies: PropTypes.instanceOf(List).isRequired,
  hasDeputyWithDeferredItems: PropTypes.bool
}

export default MyDraftDeputies
